module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Langues","b":"Aucune langue."},"en":{"a":"Languages","b":"No language."}}')
  delete Component.options._Ctor
}
